import { render, staticRenderFns } from "./LanguageHeader.vue?vue&type=template&id=e1322ae2&scoped=true"
import script from "./LanguageHeader.vue?vue&type=script&lang=ts"
export * from "./LanguageHeader.vue?vue&type=script&lang=ts"
import style0 from "./LanguageHeader.vue?vue&type=style&index=0&id=e1322ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1322ae2",
  null
  
)

export default component.exports